import { ToggleGroup, ToggleGroupItem } from "@win-reality/react-ui";
import clsx from "clsx";
import { LayoutGroup } from "framer-motion";
import { produce } from "immer";

import type { IGameState } from "../../../store/types";
import { lowerBoundedNumber } from "../../../utils/boundNumberToRange";

type Props = {
  newGameState: IGameState;
  setNewGameState: React.Dispatch<React.SetStateAction<IGameState>>;
};

const NumberAdjuster = ({
  number,
  increment,
  decrement,
}: {
  number: number;
  increment: () => void;
  decrement: () => void;
}) => (
  <div className="flex h-[45px] w-[150px] flex-row items-center justify-around rounded">
    <button
      type="button"
      className={clsx(
        // Size
        "h-[35px] w-[35px]",
        // Layout
        "flex items-center justify-center",
        // Border
        "rounded",
        // Background
        "bg-gray-800",
        // Text
        "text-[30px] text-white",
        // States
        "hover:bg-blue",
      )}
      onClick={decrement}
    >
      <span className="-mt-1">-</span>
    </button>
    <span className="font-semibold text-xl">{number}</span>
    <button
      type="button"
      className={clsx(
        // Size
        "h-[35px] w-[35px]",
        // Layout
        "flex items-center justify-center",
        // Border
        "rounded",
        // Background
        "bg-gray-800",
        // Text
        "text-[30px] text-white",
        // States
        "hover:bg-blue",
      )}
      onClick={increment}
    >
      +
    </button>
  </div>
);

export const InningChanger = ({ newGameState, setNewGameState }: Props) => {
  const { inning } = newGameState;

  return (
    <div className="flex flex-row items-center py-2.5">
      <div className="w-[35%] font-semibold text-lg">Inning</div>
      <NumberAdjuster
        number={inning.integer}
        increment={() => {
          setNewGameState(
            produce((state) => {
              state.inning.integer = inning.integer + 1;
            }),
          );
        }}
        decrement={() =>
          setNewGameState(
            produce((state) => {
              state.inning.integer = lowerBoundedNumber(1, inning.integer - 1);
            }),
          )
        }
      />
      <LayoutGroup id="inning-half">
        <ToggleGroup
          type="single"
          value={inning.half}
          onValueChange={(value) => {
            if (!value) return;
            setNewGameState(
              produce((state) => {
                state.inning.half = value;
              }),
            );
          }}
          className="ml-5"
        >
          <ToggleGroupItem value="top" className="text-sm">
            Top
          </ToggleGroupItem>
          <ToggleGroupItem value="bottom" className="text-sm">
            Bottom
          </ToggleGroupItem>
        </ToggleGroup>
      </LayoutGroup>
    </div>
  );
};
